const menuToggle = document.getElementById('menu-toggle');
const menu = document.getElementById('mobile-menu');
const mobileSubmenuToggle = document.getElementById('submenu-mobile-toggle');
const mobileSubmenu = document.getElementById('submenu');

const toggleMenu = () => {
  document.body.classList.toggle('no-scroll');
  menu.classList.toggle('open');
  menuToggle.classList.toggle('is-active');
};

const toggleMobileSubmenu = () => {
  mobileSubmenu.classList.toggle('open');
  mobileSubmenuToggle.classList.toggle('is-active');
}

const init = () => {
  if (menuToggle) {
    menuToggle.addEventListener('click', (el) => toggleMenu(), false);
  }
  if (mobileSubmenuToggle) {
    mobileSubmenuToggle.addEventListener('click', (el) => toggleMobileSubmenu(), false);
  }
};

document.addEventListener('DOMContentLoaded', function () {
  const levelTwoToggles = document.querySelectorAll('.level-two-toggle');

  levelTwoToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
          // Close all level two items that are not the clicked item
          const siblings = document.querySelectorAll('.level-two-toggle');
          siblings.forEach(function (sibling) {
              if (sibling !== toggle) {
                  const targetId = sibling.getAttribute('data-target');
                  const target = document.querySelector(targetId);
                  if (target.classList.contains('show')) {
                      sibling.click(); // Close the sibling item
                  }
              }
          });

      });
  });

  const levelOneToggles = document.querySelectorAll('.level-one-toggle');

  levelOneToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
          // Close all level two items that are not the clicked item
          const siblings = document.querySelectorAll('.level-two-toggle');
          siblings.forEach(function (sibling) {
              if (sibling !== toggle) {
                  const targetId = sibling.getAttribute('data-target');
                  const target = document.querySelector(targetId);
                  if (target.classList.contains('show')) {
                      sibling.click(); // Close the sibling item
                  }
              }
          });

      });
  });
   
});

module.exports = {
  init
};



// WEBPACK FOOTER //
// ./src/js/vanilla/menu-toggle.js